import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import "./SceletonSpaceCard.scss"

const SceletonSpaceCard = ({ key }) => {

    return (
        <div className='sceleton-space-card' key={key}>
            <Stack className='sceleton-space-card__content'>
                <Skeleton  className='sceleton-space-card__item' variant="rectangular" />
            </Stack>
        </div>
    )
}

export { SceletonSpaceCard }